import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
  IonIcon,
  IonText,
  ModalController
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { notificationsOutline } from 'ionicons/icons';

@Component({
  selector: 'app-notification-permission-modal',
  templateUrl: './notification-permission-modal.component.html',
  styleUrls: ['./notification-permission-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonIcon,
    IonText
  ]
})
export class NotificationPermissionModalComponent {

  constructor(private modalController: ModalController) {
    addIcons({ notificationsOutline });
  }

  /**
   * User chose to enable notifications
   */
  onEnableNotifications(): void {
    this.modalController.dismiss({ enableNotifications: true });
  }

  /**
   * User chose "Not Now"
   */
  onNotNow(): void {
    this.modalController.dismiss({ enableNotifications: false });
  }
}
